import { IsOptional, IsString } from 'class-validator';

export class SearchFilterModel {
  @IsOptional()
  @IsString({ each: true })
  ids: string[] | undefined;
}
